<template>
    <component :is="tag">
        <slot
            :isLoading="isLoading"
            :campaign="campaign"
            :incompleteProposal="incompleteProposal"
            :isCreatingProposal="isCreatingProposal"
            :createProposal="handleProposalCreate"
        />
    </component>
</template>
<script>
    import BaseProposalStepMixin from "./mixins/BaseProposalStepMixin";

    export default {
        name: 'CampaignProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        data() {
            return {
                isLoading: false,
                isCreatingProposal: false,
            }
        },
        methods: {
            handleProposalCreate() {
                this.isCreatingProposal = true;

                this.createProposal()
                    .then((res) => {
                        this.$router.push({name: 'v2.campaign.proposal', params: {proposal_id: res.data.id}})
                    })
                    .catch(error => this.handleHttpError(error))
                    .then(() => {
                        this.isCreatingProposal = false;
                    })
            }
        },
        created() {
            this.isLoading = true;
            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposals(),
                    ]);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    }
</script>
